import FeedbackPage from '@/components/FeedbackPage'
import { getFrequencyFeedback } from '@/utils/feedbackContent'

export default function FrequencyFeedbackPage() {
  return <FeedbackPage {...getFrequencyFeedback()} />
}
